import { FormViewField } from 'components/FormView';

export default {
  formName: 'InvestoryEnquiryFilterRow',
  validate: null,
  rowModelType: 'serverSide',
  parameters: [
    {
      id: 1,
      type: 'TEXT_FIELD',
      props: {
        label: 'Description',
        name: 'Description',
        size: 'medium',
        placeholder: '',
      }
    },
    {
      id: 2,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Product brand',
        name: 'Brand',
        lookupName: 'Prodbrand',
        size: 'medium',
        hideInV2: true,
      }
    },
    {
      id: 3,
      type: 'AUTOCOMPLETE_FIELD',
      props: {
        label: 'Stocked product',
        name: 'Stocked',
        required: false,
        hideInV2: true,
        apiPrefs: {
          path: '/CustomTypes/Lookup/ProductStockedStatus',
          method: 'GET',
          params: {
            BatchSize: 20
          }
        },
      }
    },
    {
      id: 4,
      type: 'PRODUCT_LOOKUP_FIELD',
      visible: true,
      props: {
        LookupLabel: 'Product from',
        suppressValidation: true,
        disableOptionsLookup: true,
        name: 'ProductFrom',
        size: 'medium',
      }
    },
    {
      id: 5,
      type: 'PRODUCT_LOOKUP_FIELD',
      visible: true,
      props: {
        LookupLabel: 'Product to',
        suppressValidation: true,
        disableOptionsLookup: true,
        name: 'ProductTo',
        size: 'medium',
      }
    },
    {
      id: 6,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Product group',
        name: 'ProductGroup',
        lookupName: 'ProductGroup',
        size: 'medium'
      }
    },
    {
      id: 7,
      type: 'TOGGLE_FIELD',
      props: {
        label: 'Active only',
        name: 'Active',
        required: false
      }
    },
  ] as FormViewField[]
};
